import * as yup from 'yup'

const schema = yup.object().shape({
  sourceCompany: yup.object().required(),
  destinationCompanies: yup.array().required(),
})

export default schema
